import { render } from "./VoucherMasters.vue?vue&type=template&id=486f572c&scoped=true"
import script from "./VoucherMasters.vue?vue&type=script&lang=js"
export * from "./VoucherMasters.vue?vue&type=script&lang=js"

import "./VoucherMasters.vue?vue&type=style&index=0&id=486f572c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486f572c"]])

export default __exports__